/**
 * en-GB messages added by Phase 3 task S33 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s33EnGB = {
    // Prompts to the worker's phone (push, and a text message at the second prompt)
    'lone.prompt.title': 'Are you OK?',
    'lone.prompt.body': 'Please check in. You are lone working at {site}.',
    'lone.prompt2.title': 'Please check in now',
    'lone.prompt2.body': 'You have not checked in. Your contacts will be told soon. Open the app and tap I am OK.',
    // "All clear" to the contacts who were told
    'lone.all_clear.subject': 'All clear: {person} has checked in',
    'lone.all_clear.body': '{person} (lone working at {site}) checked in at {time}. You do not need to do anything more.',
    // The ticker watchdog (platform alert email)
    'lone.monitoring.no_watchdog_email': 'Monitoring has stopped and no watchdog email address is set, so nobody is being told. Ask the platform operator to set one.',
    'lone.watchdog.subject': 'CloudSign: lone-working monitoring has stopped',
    'lone.watchdog.body': 'The lone-working check-in monitor has not run since {since}. People who are lone working are not being watched until it runs again. Please check the server.',
    // Errors
    'error.lone_working.no_session': 'You are not lone working at the moment.',
    'error.lone_working.not_allowed': 'Lone working is not switched on for you.',
    'error.lone_working.no_site': 'No site is available for this alert.',
};
//# sourceMappingURL=s33.js.map